export const ZONES_LIST_MAX_HEIGHT = 600
export const MAX_ZONES_ALLOWED_IN_MAP = 5000